export enum UserPermissions {
  AvailableAllReports = 'AvailableAllReports',
  EditReports = 'EditReports',
  EditSurveys = 'EditSurveys',
  EditUsers = 'EditUsers',
  AvailableAllOrganizations = 'AvailableAllOrganizations',
  AvailableAllClients = 'AvailableAllClients',
  CanSetUserCity = 'CanSetUserCity',
  AvailableAllUsers = 'AvailableAllUsers',
  AvailableAllUsersOfAllOrganizations = 'AvailableAllUsersOfAllOrganizations',
  AvailableAllUsersOfAllRegions = 'AvailableAllUsersOfAllRegions',
  AvailableAllRoles = 'AvailableAllRoles',
  AvailableAllRegions = 'AvailableAllRegions',
  AvailableAllMpi = 'AvailableAllMpi',
  OrganizationsMenu = 'OrganizationsMenu',
  MpiMenu = 'MpiMenu',
  CaseManagerMenu = 'CaseManagerMenu',
  MedAssistantMenu = 'MedAssistantMenu',
  OutreachWorkerMenu = 'OutreachWorkerMenu',
  ChangeStatusParticipants = 'ChangeStatusParticipants',
  SeesAllParticipantsByAllOrganization = 'SeesAllParticipantsByAllOrganization',
  CitiesMenu = 'CitiesMenu',
  SurveysMenu = 'SurveysMenu',
  DeleteRequests = 'DeleteRequests',
  AvailableUsersServicePoints = 'AvailableUsersServicePoints',
  AvailableAllUsersServicePoints = 'AvailableAllUsersServicePoints',
  DonorReportFilter = 'DonorReportFilter',
  OrganizationReportFilter = 'OrganizationReportFilter',
  ProjectTypeReportFilter = 'ProjectTypeReportFilter',
  RegionReportFilter = 'RegionReportFilter',
  UserReportFilter = 'UserReportFilter',
  AvailableAllUsersInReports = 'AvailableAllUsersInReports',
  RequestNotification = 'RequestNotification',
  AvailableAllDonors = 'AvailableAllDonors',
  AvailableUseOrCheckBox = 'AvailableUseOrCheckBox',
  ReportLevelHigh = 'ReportLevelHigh',
  ReportLevelMiddle = 'ReportLevelMiddle',
  ReportLevelLow = 'ReportLevelLow',
  EditPaymentAccrual = 'EditPaymentAccrual',
  EditPaymentPayout = 'EditPaymentPayout',
  ReopenCase = 'ReopenCase',
  ViewAllReports = 'ViewAllReports',
  EditSurveyDate = 'EditSurveyDate',
}
